import type { Patient as DsPatient } from '@etnas/design-system';
import type { Patient, PatientRef } from '@/api';
import { ageOf } from './age';

export function initialsOf(display: string): string {
  const [family, given] = display.split(',').map((s) => s.trim());
  return ((given?.[0] ?? '') + (family?.[0] ?? '')).toUpperCase() || '?';
}

/** API patient → design-system Patient (for PatientConfirmLine, SafetyConfirm-style dialogs). */
export function toDsPatient(p: Patient | PatientRef): DsPatient {
  if ('banner' in p) {
    const b = p.banner;
    return {
      initials: initialsOf(p.name.display),
      legalName: p.name.display,
      preferredName: p.name.preferred,
      pronouns: p.pronouns,
      sex: p.sex === 'female' ? 'Female' : p.sex === 'male' ? 'Male' : p.sex === 'other' ? 'Other' : 'Unknown',
      dob: p.dob,
      age: p.age,
      mrn: p.mrn,
      identity: p.identityStatus,
      deceased: p.deceased,
      allergyStatus: b.allergyStatus === 'nkda' ? 'list' : b.allergyStatus === 'unknown' ? 'not-assessed' : b.allergyStatus,
      allergies: b.allergies,
      flags: b.flags,
      encounter: b.encounter ?? undefined,
    };
  }
  return { initials: initialsOf(p.display), legalName: p.display, dob: p.dob, age: p.age || ageOf(p.dob), mrn: p.mrn, identity: p.identityStatus };
}

export const shortName = (display: string) => {
  const [family, given] = display.split(',').map((s) => s.trim());
  return given ? `${family}, ${given.split(' ')[0]}` : family;
};

export const familyName = (display: string) => display.split(',')[0].trim();

export const sexShort = (s?: string) => (s === 'female' ? 'F' : s === 'male' ? 'M' : s === 'other' ? 'X' : '');
